import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-daily-sale-update',
  templateUrl: './daily-sale-update.component.html',
  styleUrls: ['./daily-sale-update.component.scss']
})
export class DailySaleUpdateComponent implements OnInit {

  booth_code: any = null;
  from_date: any = null;
  to_date: any = null;
  title: any;
  data_loading = false;
  sale_date_list = [];
  sale_data = null;
  is_data_available = false;
  disable_update_button = true;
  document_file: any;

  constructor(private globalService: GlobalService, private httpService: HttpService) {
    this.title = this.globalService._active_display_name;
  }

  serveDailySale() {
    this.disable_update_button = true;
    let data_dict = {
      'booth_code': this.booth_code,
      'from_date': this.from_date,
      'to_date': this.to_date
    }
    console.log(data_dict);
    this.data_loading = true;
    this.is_data_available = false;
    this.httpService.serveDailySaleForByProduct(data_dict).subscribe((data) => {
      this.data_loading = false;
      if (data['available']) {
        this.is_data_available = true;
        this.sale_date_list = data['date_list'];
        this.sale_data = data['sale_dict'];
        this.document_file = data['document'];
      } else {
        alert('Invalid Booth Code');
        return false;
      }
      console.log(data);
    }, (error) => {
      this.is_data_available = false;
      this.data_loading = false;
      console.error(error);
    });
  }

  editClicked(date, sale_index) {
    this.sale_data[date][sale_index]['is_sale_qty_entered'] = false;
    this.sale_data[date][sale_index]['is_edit_clicked'] = true;
  }


  updateClicked(sale, sale_index, date) {
    console.log(sale);
    let entered_qty = this.sale_data[date][sale_index]['sales_quantity'];
    let total_quantity = this.sale_data[date][sale_index]['total_quantity'];
    if (entered_qty !== null) {
      if (entered_qty > total_quantity) {
        this.disable_update_button = true;
        alert('You cannot enter more than ' + total_quantity + ' quantity');
        this.sale_data[date][sale_index]['sales_quantity'] = null;
        return false;
      } else {
        this.httpService.updateDailySaleForByProduct(sale).subscribe((data) => {
          console.log(data);
          this.serveDailySale();
        }, (error) => {
          alert('Error While Update');
          console.error(error);
        });
      }
    }
  }

  updateEditClicked(sale, sale_index, date) {
    console.log(sale);
    let entered_qty = this.sale_data[date][sale_index]['sales_quantity'];
    let total_quantity = this.sale_data[date][sale_index]['total_quantity'];
    if (entered_qty !== null) {
      if (entered_qty > total_quantity) {
        this.disable_update_button = true;
        alert('You cannot enter more than ' + total_quantity + ' quantity');
        this.sale_data[date][sale_index]['sales_quantity'] = null;
        return false;
      } else {
        this.httpService.updateEditDailySaleForByProduct(sale).subscribe((data) => {
          console.log(data);
          this.serveDailySale();
        }, (error) => {
          alert('Error While Update');
          console.error(error);
        });
      }
    }
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    // const dialogRef = this.dialog.open(PdfPreviewComponent, {
    //   height: '700px',
    //   width: '700px',
    //   data: {
    //     'pdf': linkSource,
    //     'fileName': fileName
    //   },
    // });
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }


  saleQuantityChanged(sale_index, date) {
    this.sale_data[date][sale_index]['closing_quantity'] = 'N/A';
    let entered_qty = this.sale_data[date][sale_index]['sales_quantity'];
    let total_quantity = this.sale_data[date][sale_index]['total_quantity'];
    let closing_qty = total_quantity - entered_qty;
    console.log(entered_qty);
    if (entered_qty !== null) {
      if (entered_qty <= total_quantity) {
        this.sale_data[date][sale_index]['closing_quantity'] = closing_qty;
      }
    }
  }

  ngOnInit() {
  }

}
